/**
 * POST /api/visits { placeId: 'park' } — explorer bonus (§7.3 / §18).
 * Best-effort; offline = no-op.
 */
import { VisitsRequestSchema, VisitsResponseSchema } from '@pieskowo/shared';
import { SaveLocal } from '../../core/SaveLocal.js';

function apiBase(): string {
  try {
    const v = import.meta.env?.VITE_API_URL;
    if (typeof v === 'string' && v.length > 0) return v.replace(/\/$/, '');
  } catch {
    /* test */
  }
  return '';
}

export async function recordParkVisit(): Promise<void> {
  const body = VisitsRequestSchema.safeParse({ placeId: 'park' });
  if (!body.success) return;
  const token = SaveLocal.getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  try {
    const res = await fetch(`${apiBase()}/api/visits`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body.data),
    });
    if (!res.ok) return;
    const json: unknown = await res.json();
    VisitsResponseSchema.safeParse(json);
  } catch {
    /* offline */
  }
}
